import { render } from "./OrderBillingDetails.vue?vue&type=template&id=2e18090f&scoped=true"
import script from "./OrderBillingDetails.vue?vue&type=script&lang=js"
export * from "./OrderBillingDetails.vue?vue&type=script&lang=js"

import "./OrderBillingDetails.vue?vue&type=style&index=0&id=2e18090f&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e18090f"]])

export default __exports__